<template>
  <b-card>
    <b-row>
      <b-col
        v-for="template in templatesHalalForm"
        :key="template.slug"
        md="6"
      >
        <b-card class="mb-2 border shadow">
          <!-- VIEW MODE -->
          <div v-if="!template.isEditing">
            <h4 class="mb-1">
              {{ template.name }}
            </h4>
            <div>
              <div class="d-flex justify-content-between">
                <div>
                  <span
                    v-if="template.isLoadingFile"
                    class="text-muted font-small-3 ml-50"
                  >
                    <b-spinner
                      variant="primary"
                      label="Spinning"
                    />
                  </span>
                  <feather-icon
                    v-else
                    icon="FileTextIcon"
                    class="cursor-pointer"
                    color="blue"
                    size="40"
                    @click="downloadTemplate(template)"
                  />
                </div>
                <div>

                  <b-button
                    size="sm"
                    variant="outline-primary"
                    @click="template.isEditing = true"
                  >
                    <feather-icon
                      icon="EditIcon"
                      class="cursor-pointer"
                      size="14"
                    /> Edit
                  </b-button>
                </div>
              </div>
            </div>
          </div>

          <!-- EDIT MODE -->
          <div v-else>
            <b-form-group label="Template Name">
              <b-form-input v-model="template.name" />
            </b-form-group>

            <b-form-group label="File">
              <b-form-file
                v-model="template.file"
                accept=".pdf,.doc,.docx,.xlsx,.xls,.xlsm"
              />
            </b-form-group>

            <div class="d-flex gap-1">
              <b-button
                v-if="!template.isChangeTemplate"
                size="sm"
                variant="success"
                class="mr-1"
                @click="editTemplatesHalal(template)"
              >
                Save
              </b-button>
              <b-button
                v-if="template.isChangeTemplate"
                variant="success"
                size="sm"
                class="mr-1"
              >
                <b-spinner
                  small
                  type="grow"
                />
                Loading...
              </b-button>

              <b-button
                size="sm"
                variant="secondary"
                @click="template.isEditing = false"
              >
                Cancel
              </b-button>
            </div>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import { ref } from '@vue/composition-api'
import axios from 'axios'
import { required } from '@validations'
import decryptData from '@/store/auth/decryptData'

export default {
  data() {
    return {
      required,
      loader: false,
      validationErrors: {},
      errors: {},
      isLoadingFile: false,
    }
  },
  setup() {
    const templatesHalalForm = ref([])
    return {
      templatesHalalForm,
    }
  },

  async mounted() {
    if (this.$route.params.id) {
      this.getTemplatesDetails()
    }
  },
  methods: {
    getTemplatesDetails() {
      axios
        .get(`halal/templates/${this.$route.params.id}`)
        .then(res => {
          const template = decryptData(res.data.payload).data.slugs
          this.templatesHalalForm = template.map(t => ({
            ...t,
            isEditing: false,
            file: null, // for upload
            isLoadingFile: false,
            isChangeTemplate: false,
          }))
        })
        .catch(error => {
          this.$toasted.show(error, {
            position: 'top-center',
            duration: 3000,
          })
        })
    },
    downloadTemplate(template) {
    // eslint-disable-next-line no-param-reassign
      template.isLoadingFile = true

      axios.get(
        `/halal/templates/${this.$route.params.id}/${template.slug}/download`,
        {
          responseType: 'blob', // ✅ IMPORTANT
        },
      )
        .then(res => {
          let fileName = ''
          const contentDisposition = res.headers['content-disposition']

          if (contentDisposition) {
            const match = contentDisposition.match(/filename="?([^"]+)"?/)
            fileName = match ? match[1] : 'Halal Template'
          }

          const blob = new Blob([res.data], {
            type: res.headers['content-type'], // application/pdf
          })

          const url = window.URL.createObjectURL(blob)

          // ✅ Force download with correct filename
          const link = document.createElement('a')
          link.href = url
          link.download = fileName
          document.body.appendChild(link)
          link.click()
          link.remove()

          // Optional: cleanup
          setTimeout(() => {
            window.URL.revokeObjectURL(url)
          }, 1000)
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.$toasted.show('File not found', {
              position: 'top-center',
              duration: 3000,
            })
          }
        }).finally(() => {
        // eslint-disable-next-line no-param-reassign
          template.isLoadingFile = false
        })
    },
    editTemplatesHalal(template) {
      if (this.$route.params.id) {
        // eslint-disable-next-line no-param-reassign
        template.isChangeTemplate = true

        const formData = new FormData()

        formData.append('name', template.name)
        if (template.file) {
          formData.append('file', template.file)
        }

        axios
          .post(
            `halal/templates/${this.$route.params.id}/${template.slug}`,
            formData,
          )
          .then(() => {
            this.getTemplatesDetails()
          })
          .catch(error => {
            this.$toasted.show(error, {
              position: 'top-center',
              duration: 3000,
            })
          })
          .finally(() => {
            // eslint-disable-next-line no-param-reassign
            template.isChangeTemplate = false
          })
      }
    },
  },
}
</script>
